<template>
  <div class="intelligent">
    <div class="Rank min_h_200">
      <div class="hd">达人<span>榜</span></div>
      <div class="bd">
        <loading v-show="loading"></loading>
        <ul v-show="!loading">

          <li class="of_h"
              v-for="(user,index) in queryUserAlls"
              :key="index">
            <span v-if="index==0"
                  class="num first fc_l">{{index+1}}</span>
            <span v-else-if="index==1"
                  class="num second fc_l">{{index+1}}</span>
            <span v-else-if="index==2"
                  class="num third fc_l">{{index+1}}</span>
            <span v-else
                  class="num fc_l">{{index+1}}</span>
            <div class="photo fc_l">

              <!-- 别人 -->
              <!-- <router-link :to="/Ucenter/+user.id"
                           v-if="userid !== user.id">
                <img :src="user.headimg">
              </router-link> -->

              <!-- 进入本人 -->
              <!-- <router-link to="/Pcenter?type=0"
                           v-else>
                <img :src="user.headimg">
              </router-link> -->
              <a href="javascript:;"
                 @click="on_ucenter(user.id)">
                <img :src="user.headimg"
                     v-if="user.headimg"
                     :alt="user.username">
                <img src="@/assets/image/common/nan.png"
                     :alt="user.username"
                     v-else>
              </a>

            </div>
            <div class="name fc_l">{{user.username}}</div>
            <div class="attention fc_r"
                 v-if=" myid !== user.id">
              <button type="button"
                      v-if="user.isFollow==0"
                      class="no"
                      @click="on_follow(user.id)">关注</button>
              <button type="button"
                      v-if="user.isFollow==1 "
                      class="on hover_join"
                      @click="deletd_follow(user.id)">
                <p class="_width">已关注</p>
                <p class="_width top">取消关注</p>
              </button>

            </div>
          </li>

        </ul>
      </div>

    </div>
  </div>
</template>

<script>
import loading from '@/components/loading/loading.vue'
import { queryUserAll, isFollow } from '@/utils/api/communityFind.js'
import { Info } from '@/utils/api/login.js'


import { ta_selectUserFans, circle_follow, circle_deleteFollow, me_selectUserFans } from '@/utils/api/ucenter.js'//粉丝列表 //关注 取关


export default {
  name: "intelligent",
  data () {
    return {
      loading: true,
      queryUserAlls: [],
      isLogin_user: {},

    }
  },
  components: {
    loading
  },
  created () {
    this.myid = sessionStorage.getItem("id");
    this.is_login();//是否登陆
    this.router_url = this.$route.fullPath;//当前地址url

  },
  methods: {
    // 点击头像
    on_ucenter (authorId) {
      // 如果是自己
      if (this.isLogin_user.id && this.isLogin_user.id == authorId) {
        this.$router.push({ path: '/Pcenter?type=0' })
      } else {
        // 如果不是自己
        this.$router.push({ path: '/Ucenter/' + authorId })
        // let routeData = this.$router.resolve({ path: '/Ucenter/' + authorId })
        // window.open(routeData.href, '_blank');
      }
    },


    // 是否登录
    is_login () {
      Info().then((res) => {
        let data = res.data;
        this.isLogin = data.isLogin
        if (this.isLogin == true) {
          this.isLogin_user = data.user
        }
      })
    },


    // 达人榜
    getUsers () {
      queryUserAll({ count: 10 }).then((res) => {
        if (res.status == 200) {
          this.loading = false;
          this.queryUserAlls = res.data;

        } else {
          this.loading = false;
          this.$message.error(res.data.statusText)
        }

      })
    },


    // 关注
    on_follow (id) {
      // 未登录就去登录
      if (this.isLogin == true) {
        let params = {
          followId: id,
        }
        circle_follow(params).then((res) => {
          let data = res.data;
          this.follow_data = data;
          // 如果成功
          if (this.follow_data.code == 200) {
            this.$message({
              message: '关注成功',
              type: 'success'
            });
            this.getUsers();
          }
          else {
            this.$message.error(this.follow_data.message);

          }
        })
      } else {
        sessionStorage.setItem('router_url', this.router_url)//活动详情
        this.$router.push(
          {
            path: '/login/?state=' + 1,
          }
        )
      }
    },
    // 取消关注
    deletd_follow (id) {
      // console.log(id);
      if (this.isLogin == true) {
        let params = {
          followId: id,
        }
        circle_deleteFollow(params).then((res) => {
          let data = res.data;
          this.no_data = data;
          console.log(this.no_data);
          // 如果成功
          if (this.no_data.code == 200) {
            this.$message({
              message: '取消关注成功',
              type: 'success'
            });
            this.getUsers();
          }
          // 失败
          else {
            this.$message.error(this.no_data.message);
          }
        })
      } else {
        sessionStorage.setItem('router_url', this.router_url)//活动详情
        this.$router.push(
          {
            path: '/login/?state=' + 1,
          }
        )
      }
    },


    // getIsFollow (id) {
    //   // 未登录就去登录
    //   if (this.isLogin == true) {
    //     isFollow({
    //       followId: id
    //     }).then(res => {
    //       console.log(res);
    //       this.getUsers();
    //     })
    //   } else {
    //     sessionStorage.setItem('router_url', this.router_url)//活动详情
    //     this.$router.push(
    //       {
    //         path: '/login/?state=' + 1,
    //       }
    //     )
    //   }
    // }
  },
  mounted () {
    this.getUsers()
  }
}
</script>

<style lang="scss" scoped="scoped">
.attention button p {
  height: 100%;
  line-height: 0.25rem;
}
.hover_join {
  position: relative;
  overflow: hidden;
}
.top {
  top: 0.25rem;
  transition: all 0.3s;
}
.hover_join:hover .top {
  position: absolute;
  top: 0;
  color: #d4011a !important;
  // background-color: #d4011a;
}

div.Rank {
  background: #fff;
  padding: 15px;
  padding-top: 5px;
  border-radius: 5px;
  div.hd {
    height: 45px;
    line-height: 45px;
    font-size: 18px;
    font-weight: bold;
    padding: 0px;
    border-bottom: 1px #ddd solid;
    span {
      color: #da131a;
    }
  }

  div.bd {
    ul {
      // padding-bottom: 20px;
      padding: 13px 13px 20px;
      box-sizing: border-box;
      li {
        height: 45px;
        margin-top: 15px;
        span {
          &.num {
            display: inline-block;
            width: 18px;
            height: 18px;
            border-radius: 50%;
            line-height: 18px;
            margin-top: 14px;
            font-weight: bold;
            font-size: 14px;
            font-family: "PingFang SC", "Lantinghei SC", "Microsoft YaHei",
              "HanHei SC", "Helvetica Neue", "Open Sans", Arial,
              "Hiragino Sans GB", "微软雅黑", STHeiti, "WenQuanYi Micro Hei",
              SimSun, sans-serif;
            text-align: center;
            color: #333;
          }

          &.first {
            background: #d60219;
            color: #fff;
          }
          &.second {
            background: #ff6600;
            color: #fff;
          }
          &.third {
            background: #feab0f;
            color: #fff;
          }
        }
        div.photo {
          width: 45px;
          height: 45px;
          margin-left: 10px;
          img {
            display: block;
            width: 45px;
            height: 45px;
            border-radius: 50%;
          }
        }
        div.name {
          width: 160px;
          height: 45px;
          line-height: 45px;
          padding: 0 20px;
          font-size: 14px;
          color: #333;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          box-sizing: border-box;
        }
        div.character {
          width: 70px;
          height: 45px;
          line-height: 45px;
          color: #888;
          font-size: 14px;
          padding-left: 10px;
          img {
            display: inline-block;
            width: 18px;
            height: 16px;
            vertical-align: middle;
            margin-top: -6px;
            margin-right: 4px;
          }
        }
        div.attention {
          width: 57px;
          margin-top: 9px;
          button {
            display: block;
            width: 57px;
            height: 25px;
            line-height: 23px;
            border-radius: 4px;
            text-align: center;
            transition: all 0.3s;
            color: #d3011a;
            border: 1px #d3011a solid;
            background: #fff;
          }
          button.on {
            color: #d3011a;
            border: 1px #d3011a solid;
          }
          button.on:hover {
            color: #fff;
            // background: #d3011a;
          }
          button.no {
            color: #666;
            border: 1px #ddd solid;
          }
          button.no:hover {
            color: #d3011a;
            border: 1px #d3011a solid;
          }
        }
      }
    }
  }
  .bd li:nth-child(1) {
    margin-top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/community/intelligent/intelligent.vue